import { createFileRoute } from "@tanstack/react-router";

import { AuthorizationPageGate } from "@/features/admin/authorization/_components/authorization-page-gate";
import { AuthorizationList } from "@/features/admin/authorization/list";

export const Route = createFileRoute("/admin/authorization/")({
  component: () => (
    <AuthorizationPageGate>
      <AuthorizationList />
    </AuthorizationPageGate>
  ),
});
